import { render, staticRenderFns } from "./HeroText.vue?vue&type=template&id=079755be&scoped=true"
import script from "./HeroText.vue?vue&type=script&lang=js"
export * from "./HeroText.vue?vue&type=script&lang=js"
import style0 from "./HeroText.vue?vue&type=style&index=0&id=079755be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079755be",
  null
  
)

export default component.exports